package com.dotdrives.client
import com.dotdrives.config.BuildKonfig
import com.dotdrives.core.uuidV7
import com.dotdrives.model.*
import io.github.jan.supabase.SupabaseClient
import io.github.jan.supabase.auth.auth
import io.github.jan.supabase.postgrest.from
import io.github.jan.supabase.postgrest.postgrest
import io.github.jan.supabase.postgrest.query.Order
import io.ktor.client.HttpClient
import io.ktor.client.request.*
import io.ktor.client.statement.bodyAsText
import io.ktor.http.*
import kotlinx.serialization.json.*
class GiverExperienceClient(private val client:SupabaseClient=SupabaseProvider.client,
 private val baseUrl:String=BuildKonfig.SUPABASE_URL,private val publicKey:String=BuildKonfig.SUPABASE_PUBLISHABLE_KEY,
 private val httpFactory:()->HttpClient={HttpClient()}) {
 private val json=Json {ignoreUnknownKeys=true}
 suspend fun stats(orgId:String,giverId:String):GiverExperienceStats=client.postgrest.rpc("giver_experience",buildJsonObject {put("p_org",orgId);put("p_giver",giverId)}).decodeAs()
 suspend fun gifts(orgId:String,giverId:String):List<GiverGift> = fetchAllPages(1000) { offset -> client.from("donations").select {
  range(offset,offset+999);order("occurred_at",Order.DESCENDING);order("id",Order.ASCENDING);filter {eq("org_id",orgId);eq("giver_id",giverId)}
 }.decodeList<GiverGift>() }
 suspend fun statements(orgId:String,giverId:String):List<GiverStatement> = fetchAllPages(1000) { offset -> client.from("giving_statements").select {
  range(offset,offset+999);order("year",Order.DESCENDING);order("id",Order.ASCENDING);filter {eq("org_id",orgId);eq("giver_id",giverId)}
 }.decodeList<GiverStatement>() }
 suspend fun files(orgId:String,giverId:String):List<GiverFile> = fetchAllPages(1000) { offset -> client.from("files").select {
  range(offset,offset+999);order("created_at",Order.DESCENDING);order("id",Order.ASCENDING);filter {eq("org_id",orgId);eq("owner_type","giver");eq("owner_id",giverId)}
 }.decodeList<GiverFile>() }
 suspend fun upload(orgId:String,giverId:String,name:String,mime:String,bytes:ByteArray) {
  require(bytes.isNotEmpty()&&bytes.size<=MAX_GIVER_FILE_BYTES) {"Choose a file between 1 byte and 20 MiB"}
  require(mime in giverFileMimeTypes) {"Choose a PDF, image, plain text, or CSV file"}
  require(name.isNotBlank()&&name.length<=255) {"File name must be 1–255 characters"}
  val id=uuidV7();val path="$orgId/giver/$giverId/$id"
  request("/storage/v1/object/org-private/$path",bytes,mime)
  client.from("files").insert(buildJsonObject {put("id",id);put("org_id",orgId);put("owner_type","giver");put("owner_id",giverId);put("storage_path",path);put("file_name",name);put("file_size",bytes.size);put("uploaded_by",AuthClient(client).requireCurrentUserId())})
 }
 suspend fun downloadFile(orgId:String,giverId:String,file:GiverFile):String {
  // Resolve trusted current metadata again; never sign a UI-supplied arbitrary path.
  val current=client.from("files").select {filter {eq("org_id",orgId);eq("owner_type","giver");eq("owner_id",giverId);eq("id",file.id)}}.decodeSingle<GiverFile>()
  val prefix="$orgId/giver/$giverId/"
  require(current.storagePath.startsWith(prefix)&&current.storagePath.removePrefix(prefix).matches(Regex("[A-Za-z0-9._-]+"))) {"File unavailable"}
  val response=request("/storage/v1/object/sign/org-private/${current.storagePath}","""{"expiresIn":300}""")
  val signed=response["signedURL"]?.jsonPrimitive?.content?:error("File unavailable")
  require(signed.startsWith("/object/sign/org-private/$prefix")) {"File unavailable"}
  return "${baseUrl.trimEnd('/')}/storage/v1$signed"
 }
 suspend fun downloadStatement(id:String):DocumentDownload=json.decodeFromJsonElement(workflow("statement.download",id))
 suspend fun retryStatement(id:String) {workflow("statement.retry",id)}
 suspend fun requestStatement(orgId:String,giverId:String,year:Int):String=client.postgrest.rpc("request_giving_statement",buildJsonObject {put("p_org",orgId);put("p_giver",giverId);put("p_year",year)}).decodeAs()
 private suspend fun workflow(action:String,id:String):JsonElement=request("/functions/v1/workflows",buildJsonObject {put("action",action);put("statement_id",id)}.toString())["data"]?:error("Document unavailable")
 private suspend fun request(path:String,body:Any,mime:String="application/json"):JsonObject {
  val jwt=client.auth.currentSessionOrNull()?.accessToken?:error("Sign in again")
  val http=httpFactory()
  try {
   val response=http.post("${baseUrl.trimEnd('/')}$path") {header("apikey",publicKey);bearerAuth(jwt);contentType(ContentType.parse(mime));setBody(body)}
   if(!response.status.isSuccess())error(if(response.status.value in listOf(401,403))"You do not have access to this file or document" else "The request failed. Please try again.")
   return json.parseToJsonElement(response.bodyAsText()).jsonObject
  } finally {http.close()}
 }
}
